import React from 'react';

import type { ModalState, UserSection } from '../../types';

interface ModalsContainerProps {
  modalState: ModalState;
  userSections: UserSection[];
  onCloseModal: () => void;
}

function ModalsContainer({ modalState, userSections, onCloseModal }: ModalsContainerProps) {
  return (
    <>
      {/* Role/Mission Modal */}
      {modalState.type === 'role' && modalState.sectionId && (
        <div 
          className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/40"
          onClick={onCloseModal}
          style={{ backdropFilter: 'blur(4px)' }}
        >
          <div 
            className="max-h-[80vh] w-[90%] max-w-2xl overflow-y-auto rounded-xl border border-gray-200 bg-white p-8 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mb-6 flex items-start justify-between border-b border-gray-200 pb-4">
              <h3 className="text-lg font-semibold text-gray-800">
                {userSections.find(s => s.id === modalState.sectionId)?.title} - RÔLE ET MISSION
              </h3>
              <button 
                className="text-xl font-bold text-gray-400 transition-colors hover:text-gray-600"
                onClick={onCloseModal}
              >
                ×
              </button>
            </div>
            <div className="text-sm leading-relaxed text-gray-600">
              {userSections.find(s => s.id === modalState.sectionId)?.roleDescription}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ModalsContainer;
